import Proveedores from "./Proveedores";
export default Proveedores;